import React, { useCallback, useState } from 'react';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLModalService } from 'ml-portals-services-react';
import { ReinstatementService } from 'ml-capability-reinstatement';
import Reinstatement from '../../model/Reinstatement';

import metadata from './MLReinstatePolicyPage.metadata.json5';
import messages from './MLReinstatePolicyPage.messages';
import styles from './MLReinstatePolicyPage.module.scss'

function MLReinstatePolicyPage(props) {
    const {
        updateWizardData, wizardData, goNext
    } = props;
    const { submissionVM } = wizardData;
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const [showErrors, updateShowErrors] = useState(false);
    const { isComponentValid, onValidate } = useValidation('reinstatePolicy');

    const ModalService = MLModalService();

    const onNext = useCallback(() => {
        if (!(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            updateShowErrors(true);
            return;
        }
        const model = submissionVM.value;
        const promise = ReinstatementService.saveAndBindReinstatement(model, authHeader).then((result) => {
            submissionVM.value = new Reinstatement(result);
            updateWizardData(wizardData);
            goNext();
        });
        ModalService.showProgressDialog(messages.bind, promise);
        promise.catch((error) => {
            error.modalTitle = translator(messages.bindErrorTitle);
            error.modalMessage =  translator(messages.bindErrorMsg);
            throw error;
        });
    }, [submissionVM, ModalService, authHeader, updateWizardData, wizardData, goNext, translator]);

    const getNextStepText = () => {
        return (
            <>
                {translator(messages.nextDescription, {
                    strong: (chunks) => <strong>{chunks}</strong>
                })}
            </>
        );
    };

    const overrideProps = {
        effectiveDate: {
            readOnly: true
        },
        nextDescription: {
            content: getNextStepText(),
        },
        stickyContinueSection: {
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText(),
            onNext
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onNext
        }
    }

    return (
        <WizardPage
            showCancel={false}
            showNext={false}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                onValidationChange={onValidate}
                showErrors={showErrors}
                
            />
        </WizardPage>
    );
}

export default MLReinstatePolicyPage;